import { render, staticRenderFns } from "./CollectionUpdater.vue?vue&type=template&id=45e5497c&"
import script from "./CollectionUpdater.vue?vue&type=script&lang=ts&"
export * from "./CollectionUpdater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports